import { observer } from 'mobx-react-lite';
import ClassString from '@utils/class-string.ts';
import Form from '@components/core/form/form.tsx';
import InputText from '@components/core/input-text/input-text.tsx';
import { INPUT_TEXT_TYPES } from '@components/core/input-text/input-text-enum.ts';
import Button from '@components/core/button/button.tsx';
import { BUTTON_STYLE } from '@components/core/button/button-style-enum.ts';
import { useState } from 'react';
import validationService from '@services/validation-service.ts';
import toastStore from '@store/toast-store.ts';
import { ToastType } from '@components/service/toast/toast-enums.ts';
import authStore from '@store/auth-store.ts';

interface SignInForgotPasswordFormProps {
	className?: string;
}

const SignInForgotPasswordForm = observer(function SignInForgotPasswordFormForm(
	props: SignInForgotPasswordFormProps
) {
	const [email, setEmail] = useState('');

	const [loadingResetPassword, setLoadingResetPassword] = useState(false);
	const [passwordResetSuccess, setPasswordResetSuccess] = useState(false);

	const handleForgotPassword = async () => {
		if (!validationService.email(email)) {
			toastStore.emit('Invalid email', ToastType.ERROR);
			return;
		}

		setLoadingResetPassword(true);

		const resp = await authStore.requestPasswordChange(email);

		if (resp.ok) {
			setPasswordResetSuccess(true);
		}
		setLoadingResetPassword(false);
	};

	return (
		<>
			<div
				className={ClassString({
					static: 'flex flex-col justify-center items-center mb-4',
					dynamic: { hidden: passwordResetSuccess },
					custom: props.className,
				})}
			>
				<div className={'w-full mb-4'}>
					Enter your email to request a password reset
				</div>

				<Form
					className={
						'flex flex-col justify-center items-center w-full'
					}
					onSubmit={() => {
						void handleForgotPassword();
					}}
				>
					<InputText
						label={'Email'}
						value={email}
						name={'email'}
						onInput={(event) => setEmail(event.target.value)}
						type={INPUT_TEXT_TYPES.EMAIL}
						options={{ width: '100%', large: true }}
						inputClassName={'bg-transparent'}
					/>

					<Button
						title={'Request Password Reset'}
						buttonStyle={BUTTON_STYLE.PRIMARY}
						className={'mt-2 w-full py-6 rounded-full max-w-80'}
						loading={loadingResetPassword}
					/>
				</Form>
			</div>

			<div
				className={ClassString({
					static: 'flex flex-col justify-center items-center mb-4',
					dynamic: {
						hidden: !passwordResetSuccess,
					},
					custom: props.className,
				})}
			>
				<div className={'w-full text-center'}>
					If there’s an account connected to this email, we’ll send
					you instructions to set a new password.
				</div>
			</div>
		</>
	);
});

export default SignInForgotPasswordForm;
